import { Store } from "../utils/Store";
import PromptActions from "../actions/PromptActions";
import { isCookieExists } from "../utils/CookieLawUtil";
import { SessionStore } from "../uidispatcherapi/SessionStore";
import { GdprStorage } from "../uidispatcherapi/GdprStorage";
import { CreativeElement } from "../datatypes/Creatives";
import * as TrackingUtil from "../utils/TrackingUtil";

const LOGIN_PROMPT_COOKIE = "loginPromptCapped";
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

const COUNTRY_CREATIVES = {
    /*
  FR: [
      {
          type: "MAC",
          imageUrl: "https://api.prod.cia.metro.cloud/cia/banner/default-heroBanner.jpg"
      },
      {
          type: "h1",
          text: "Tous vos produits livrés directement chez vous."
      },
      {
          type: "text",
          text: "Inscrivez-vous et bénéficiez d'un code promo d'une valeur de 30€ !"
      },
      {
          type: "buttonRow",
          buttons: [
              {
                  text: "Se connecter",
                  trackingName: "login.trigger",
                  target: {
                      type: "REL_LINK",
                      data: "/login"
                  }
              },
              {
                  text: "S'inscrire",
                  trackingName: "register.trigger",
                  target: {
                      type: "PURE_LINK",
                      data: "https://monidentifiant.metro.fr/signup"
                  }
              }
          ]
      },
      {
          type: "footnote",
          text: "A partir de 300€ d'achat sur tout l'équipement. Consulter les conditions particulières de vente."
      }
  ]
  */
} as any;

type PromptState = {
    dismissed: boolean;
};

let state: PromptState;

class PromptStoreImpl extends Store {
    constructor() {
        super();
        this.listenTo(PromptActions.dismissLoginPrompt, this.dismissLoginPrompt);
        state = this.getEmptyState();
    }

    getEmptyState(): PromptState {
        return {
            dismissed: false
        };
    }

    getInitialState(): PromptState {
        return {
            dismissed: this.getLoginPromptCapped()
        };
    }

    dismissLoginPrompt() {
        state.dismissed = true;
        try {
            (GdprStorage as any).cookie.put(LOGIN_PROMPT_COOKIE, "1", GdprStorage.FUNCTIONAL, {
                expires: this.getPromptExpiryDate(),
                domain: SessionStore.getCookieDomain()
            });
        } catch (e) {
            TrackingUtil.trackUIError("PromptStore", "Could not set capping cookie", e);
        }
        this.trigger();
    }

    getCookiesAllowed(): boolean {
        // There's no need to listen / trigger on that cookie.
        // LoginPrompt can just show up when we switch to another page.
        return isCookieExists();
    }

    getLoginPromptCreative(): Array<CreativeElement> {
        const country: string = SessionStore.getCountry();
        const creative = COUNTRY_CREATIVES[country];
        return creative;
    }

    getLoginPromptCapped(): boolean {
        return state.dismissed || !!(GdprStorage as any).cookie.read(LOGIN_PROMPT_COOKIE);
    }

    getPromptExpiryDate(): Date {
        const numDays = 60;
        return new Date(new Date().getTime() + numDays * MILLISECONDS_PER_DAY);
    }
}

export const PromptStore = new PromptStoreImpl();
